import { format } from 'date-fns';
import type { Locale } from 'date-fns';
import type { Trip, ItineraryDay } from '../../../types';
import type { TripRouteShape } from './routeShape';
import type { StickerStat } from './stickerSpec';

/** Turning trip data into the handful of strings a sticker actually shows. */

interface StatLabels {
  days: string;
  stops: string;
  distance: string;
}

export function buildStickerStats(
  days: ItineraryDay[],
  shape: TripRouteShape,
  labels: StatLabels,
): StickerStat[] {
  const stats: StickerStat[] = [
    { label: labels.days, value: String(days.length) },
    { label: labels.stops, value: String(shape.stops.length) },
  ];

  // An interpolated shape measures straight lines between stops, which reads as
  // a real odometer figure while being off by a third. Better to say nothing.
  if (!shape.approximate && shape.distanceM > 0) {
    stats.push({ label: labels.distance, value: `${Math.round(shape.distanceM / 1000)} km` });
  }
  return stats;
}

export function formatTripDates(trip: Trip, locale: Locale): string {
  const start = new Date(trip.startDate);
  const end = new Date(trip.endDate);
  const sameYear = start.getFullYear() === end.getFullYear();
  return `${format(start, sameYear ? 'd MMM' : 'd MMM yyyy', { locale })} – ${format(end, 'd MMM yyyy', { locale })}`;
}

export function fileSlug(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'trip';
}
